const toggle = document.querySelector('[data-search-toggle]');
const panel = document.querySelector('[data-search-panel]');
const input = document.querySelector('[data-search-input]');
const results = document.querySelector('[data-search-results]');
let controller;

toggle?.addEventListener('click', () => { panel.hidden = !panel.hidden; if (!panel.hidden) input.focus(); });

input?.addEventListener('input', async (e) => {
  const q = e.target.value.trim();
  if (q.length < 2) { results.innerHTML = ''; return; }
  controller?.abort();
  controller = new AbortController();
  try {
    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article`, { signal: controller.signal });
    const data = await res.json();
    const products = data.resources.results.products || [];
    const articles = data.resources.results.articles || [];
    results.innerHTML = products.map(p => `<a class="sr" href="${p.url}"><img src="${p.image}" width="48"><span>${p.title}</span><span class="price">${p.price}</span></a>`).join('')
      + articles.map(a => `<a class="sr" href="${a.url}">${a.title}</a>`).join('');
  } catch {}
});
